import * as ng from 'angular';
import * as _ from 'underscore';
import * as uir from '@uirouter/angularjs';
import * as nggt from 'angular-gettext';

import { EventDetail, EventListService } from '../events';
import { SiteConfig, Loader, SyncService, Participant } from '../shared';
import { TimeoutService } from '../timeout';

const locales = _.chain(require('../../../../../langs.json'))
   .map((l:any) => [l.code, l.locale])
   .object()
   .value();

resolveEvent.$inject = ['events', '$stateParams', 'eventListService'];
export function resolveEvent(events:EventDetail[], $stateParams:uir.StateParams, eventListService:EventListService) {
   var event = _.findWhere(events, {id: $stateParams.eventId});
   if (event) {
      return event;
   }

   // `events` could be null if user denied location lookup
   // or `events` might not contain event with the given id
   return eventListService.get($stateParams.eventId);
}

export class RegisterController implements ng.IComponentController {
   static $inject = [
      '$stateParams', '$state', 'config', 'gettextCatalog', 'syncService', 'loader', 'timeoutService'
   ];

   constructor(
      private $stateParams:uir.StateParams,
      private $state:uir.StateService,
      private config:SiteConfig,
      private gettextCatalog:nggt.gettextCatalog,
      private syncService:SyncService,
      private loader:Loader,
      private timeoutService:TimeoutService
   ) {
      this.pageIndex = 0;
      if ($stateParams.page !== 1) {
         // when first loading registration form, we have to start on page one
         // this includes hitting reload on any page after page one
         this.$state.go('.', { page: 1 });
      }
   }

   $onInit() {
      this.participant = this.syncService.newParticipant(this.event);

      if (this.config.settings.allowGuestTypeInURL) {
         this.participant.guestTypeSlug = this.$stateParams.guestType;
      }

      if (!this.config.settings.doubleAgeEntry) {
         this.participant.dob = this.$stateParams.dob;
      }
   }

   uiOnParamsChanged(newValues:any, $transition$:uir.Transition) {
      if (newValues.page) {
         this.pageIndex = newValues.page - 1;

         if (selfRegExt.pageChange) {
            selfRegExt.pageChange(this.pageIndex, this.participant, this.config);
         }
      }
   }

   LayoutView = {
      FORM: 'form',
      FORM_BOT_CHECK: 'bot_check',
      FORM_ERROR: 'error'
   };

   mode = this.LayoutView.FORM;
   pageIndex:number;
   event:EventDetail;
   participant:Participant;
   errors:string[];
   private specificErrorKeys = ['event_over', 'event_not_started', 'already_registered_once', 'already_registered_today'];

   get pageConfig() {
      return this.config.settings.pages[this.pageIndex];
   }

   get language() {
      return this.gettextCatalog.getCurrentLanguage();
   }

   get titleText() {
      return this.pageConfig.titleText[this.language];
   }

   onContinue(form:ng.IFormController, e:MouseEvent) {
      if (!this.timeoutService.checkSession()) {
         return;
      }

      if (!form.$valid) {
         form.$setSubmitted();
         return;
      }

      let goto = (index:number) => {
         // prevents validation feedback from displaying on next page
         // chrome seems to cancel the form submit with this...
         e.preventDefault();
         // firefox canceling event has no effect, need to reset form state
         form.$setPristine();

         // NOTE in context of switching pages index is "1" based
         this.$state.go('.', {
            page: index + 1
         });
      };

      if (selfRegExt.navigate) {
         let next = selfRegExt.navigate(this.pageIndex, this.participant);
         if (next) {
            goto(next);
         } else {
            this.onRegistrationComplete();
         }
      } else {
         if (this.pageIndex < this.config.settings.pages.length - 1) {
            goto(this.pageIndex + 1);
         } else {
            this.onRegistrationComplete();
         }
      }
   }

   private onRegistrationComplete() {
      if (this.config.settings.requireMediaUpload) {
         // temporarily store participant in storage and later submit after photo selection and captcha on Media Upload
         this.syncService.setParticipant(this.participant);
         this.$state.go('shell.mediaUpload', {
            wristbandId: this.participant.wristbandID,
            eventId: this.participant.eventID
         });
      } else {
         this.initilizeTurnstile();
      }
   }

   private submit(token) {
      this.errors = null;
      this.loader.loading = true;
      this.participant.locale = locales[this.language];
      this.syncService.submit(this.participant, token).then(() => {
         this.$state.go('shell.confirm', {
            wristbandId: this.participant.wristbandID
         });
      }).catch(response => {
         this.mode = this.LayoutView.FORM_ERROR;
         if (response.data.errors && response.data.errors['']) {
            this.errors = response.data.errors[''];
         }
      }).finally(() => this.loader.loading = false);
   }

   initilizeTurnstile() {
      this.mode = this.LayoutView.FORM_BOT_CHECK;
   }

   onTurnstileCallback(token:string) {
      this.submit(token);
   }

   onTurnstileErrorCallback() {
      this.mode = this.LayoutView.FORM_ERROR;
   }

   hasSpecificErrors() {
      return this.errors && this.errors.some(error => this.specificErrorKeys.includes(error));
   }
}

ng.module('selfReg').component('register', {
   templateUrl: require('./register.html'),
   controller: RegisterController,
   bindings: {
      event: '<'
   }
});
